import type { AlunoVisao360 } from '@/domain/model/AlunoVisao360';
import type { GetAlunoVisao360UseCase } from '@/application/port/in/GetAlunoVisao360UseCase';
import type { AlunoVisao360Gateway } from '@/application/port/out/AlunoVisao360Gateway';

export class GetAlunoVisao360 implements GetAlunoVisao360UseCase {
  constructor(private readonly gateway: AlunoVisao360Gateway) {}
  execute(alunoId: string): Promise<AlunoVisao360> {
    return this.gateway.fetchVisao360(alunoId);
  }
}
